import { db } from "@/api/firebase";
import {
  Quests,
  Q_StatusGoal,
  Q_StatusGoal_w_detail,
} from "@/models/MapPois/Quest/Quests";
import {
  Q_POI_STATUS,
  Q_QUEST_STATUS,
  Q_QUEST_TYPE,
} from "@/models/MapPois/Quest/QuestsEnum";
import { toArray } from "lodash";
import { Module, VuexModule, Action, Mutation } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class QuestStore extends VuexModule {
  quest: Quests[] = [];
  questObject = {} as Quests;
  isEditing = false;
  questSlug = "";

  @Mutation
  setQuest(quest: Quests[]): void {
    this.quest = quest;
  }

  @Mutation
  setQuestSlug(questSlug: string): void {
    this.questSlug = questSlug;
  }


  @Mutation
  setQuestObject(questObject: any): void {
    this.questObject = questObject;
  }

  @Mutation
  currentlyEditing(value: boolean): void {
    this.isEditing = value;
  }

  @Action
  public async getQuestForGame(key: string): Promise<boolean> {
    try {
      db.ref("quests/" + this.questSlug).off();
      this.context.commit("setQuestSlug", key);
      db.ref("quests/" + key).on("value", (results) => {
        this.context.commit("setQuest", toArray(results.val()));
        this.context.commit("setQuestObject", results.val());
      });
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  @Action({ rawError: true })
  public async updateQuest(data: any): Promise<string> {
    try {
      await db
        .ref("quests/" + data.game_uid + "/" + data.questData.key)
        .update(data.questData);
      return "success";
    } catch (error) {
      console.log(error);
      return "failed";
    }
  }

  @Action({ rawError: true })
  public async insertNewQuest(data: any): Promise<void> {
    try {
      const questGoal = {
        status: Q_POI_STATUS.NONE,
      } as Q_StatusGoal;
      const questGoalDetail = {
        status: Q_POI_STATUS.NONE,
        goalTitle: { en: "" },
        goalDesc: { en: "" },
      } as Q_StatusGoal_w_detail;
      const questData = {
        type: data.type,
        title: { en: data.title },
        desc: { en: data.desc },
        status: Q_QUEST_STATUS.NONE,
        imgs: data.imgs,
        key: "",
        statusGoals: {
          [Q_QUEST_STATUS.NONE]: questGoal,
          [Q_QUEST_STATUS.UNLOCKED]: questGoalDetail,
          [Q_QUEST_STATUS.ACTIVE]: questGoalDetail,
          [Q_QUEST_STATUS.COMPLETE]: questGoalDetail,
          [Q_QUEST_STATUS.FAILED]: questGoalDetail,
          [Q_QUEST_STATUS.CANCELLED]: questGoal,
          [Q_QUEST_STATUS.FINAL]: questGoal,
          [Q_QUEST_STATUS.DONE]: questGoal,
        },
      } as Quests;
      const key = await db.ref("/quests/" + data.gameKey).push().key;
      if (key != null) {
        questData.key = key;
      }
      db.ref("quests/" + data.gameKey + "/" + key).set(questData);
    } catch (error) {
      console.log(error);
    }
  }
  @Action({ rawError: true })
  public async insertFirstQuest(data: any): Promise<void> {
    try {
      const questGoal = {
        status: Q_POI_STATUS.NONE,
      } as Q_StatusGoal;
      const questGoalDetail = {
        status: Q_POI_STATUS.NONE,
        goalTitle: { en: "" },
        goalDesc: { en: "" },
      } as Q_StatusGoal_w_detail;
      const questData = {
        type: Q_QUEST_TYPE.MAIN,
        title: { en: "Main Quest" },
        desc: { en: "A Default Main Quest" },
        status: Q_QUEST_STATUS.NONE,
        imgs: data.imgs,
        key: "MAIN",
        statusGoals: {
          [Q_QUEST_STATUS.NONE]: questGoal,
          [Q_QUEST_STATUS.UNLOCKED]: questGoalDetail,
          [Q_QUEST_STATUS.ACTIVE]: questGoalDetail,
          [Q_QUEST_STATUS.COMPLETE]: questGoalDetail,
          [Q_QUEST_STATUS.FAILED]: questGoalDetail,
          [Q_QUEST_STATUS.CANCELLED]: questGoal,
          [Q_QUEST_STATUS.FINAL]: questGoal,
          [Q_QUEST_STATUS.DONE]: questGoal,
        },
      } as Quests;
      db.ref("quests/" + data.gameKey + "/MAIN/").set(questData);
    } catch (error) {
      console.log(error);
    }
  }

  @Action({ rawError: true })
  public async deleteQuest(data: any): Promise<void> {
    try {
      await db.ref("/quests/" + data.gameUid + "/" + data.key).remove();
    } catch (error) {
      console.log(error);
    }
  }
}
